import React, { useEffect, useMemo, useRef, useState } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Box, Button, Grid, Stack } from '@mui/material';
import AddRefundRequest from './AddRefundRequest';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';
import {
  REFUND_REQUEST_TABLE_HEAD,
  TableHead_Refund_fn,
} from '../../components/datagrid/refund/RefundRequestTableHead';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react/dist/iconify.js';
import ViewRefundDetails from './ViewRefundDetails';
import GlobalRefundApprovalReject from './GlobalRefundApprovalReject';
import RequestStats from './RequestStats';
import ToolTip from '../../components/ToolTip/ToolTip';
import FromAndToDatePicker from '../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormikNew from '../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { refundGlobalStatus } from '../../utils/constants/GlobalStaticData';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { getPmRefundRequests } from '../../redux/features/refundSlice';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import ReasonEdit from './verify_approve/components/ReasonEdit';
import TutorsTable from './verify_approve/components/TutorsTable';
import DetailsAction from './verify_approve/components/DetailsAction';
import { openChat, setRefreashNeeded } from '../../redux/features/chatSlice';

const RefundRequestPM = () => {
  const [openRejectionReason, setOpenRejectionReason] = useState(false);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;
  const { loading, refundRequestPmData } = useSelector((state) => state.refund);
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [selectedRow, setSelectedRow] = useState(null);
  const [approvalModal, setApprovalModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState({});
  const dispatch = useDispatch();
  const [openTutorsTable, setOpenTutorsTable] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [editReason, setEditReason] = useState('');
  const [chatOpen, setChatOpen] = useState(false);
  const { open: chatOpenFromRedux, refreashNeeded } = useSelector((state) => state.chat);
  const prevOpenRef = useRef(chatOpenFromRedux);

  const dispatchParams = useMemo(() => {
    return {
      gridSize,
      pageNum,
      search,
      fromDate,
      toDate,
      status: selectedStatus?.id,
    };
  }, [pageNum, gridSize, search, fromDate, toDate]);

  useEffect(() => {
    dispatch(getPmRefundRequests(dispatchParams));
  }, [dispatch, dispatchParams]);

  useEffect(() => {
    if (!chatOpen || !selectedRow) return;
    dispatch(
      openChat({
        chatRoomId: selectedRow?.chat_room_id || null,
        groupCreationUsersList: selectedRow?.related_users || [],
        groupName: `Refund - ${selectedRow?.student_name}-${selectedRow?.expense_id}`,
        rowDetails: selectedRow,
      })
    );
    setChatOpen(false);
  }, [chatOpen]);

  useEffect(() => {
    const justClosed = prevOpenRef.current === true && chatOpenFromRedux === false;
    if (justClosed && refreashNeeded) {
      dispatch(getPmRefundRequests(dispatchParams));
      dispatch(setRefreashNeeded(false));
    }
    prevOpenRef.current = chatOpenFromRedux;
  }, [chatOpenFromRedux, dispatchParams,refreashNeeded]);

  const COLUMNS = useMemo(
    () =>
      TableHead_Refund_fn({
        setOpenTutorsTable,
        setOpenRejectionReason,
        selectedType: 0,
        setOpenDetails,
        setChatOpen,
        setSelectedRow,
        setApprovalModal,
        setEditReason,
        approvalOrVerify: true,
      }),
    []
  );

  const GLOBAL_DIALOGUE = [
    {
      open: openRejectionReason,
      setOpen: setOpenRejectionReason,
      title: 'Bank Account Details',
      content: <ReasonEdit setOpen={setOpenRejectionReason} reason={editReason} rowData={selectedRow} />,
    },
    {
      open: Boolean(openTutorsTable),
      setOpen: setOpenTutorsTable,
      title: 'Tutors',
      content: <TutorsTable ids={openTutorsTable} />,
    },
    {
      open: Boolean(openDetails),
      setOpen: setOpenDetails,
      title: 'Details',
      content: <DetailsAction data={openDetails} />,
    },
  ];

  return (
    <GlobalWrapper title={'Refund Request'}>
      <Box sx={{ width: '100%' }}>
        <Box>
          <RequestStats loading={loading} requestStats={refundRequestPmData?.meta} />
        </Box>
        <Grid container spacing={2} my={3}>
          <Grid item xs={12} md={6} lg={4}>
            <FromAndToDatePicker
              disabled={false}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
              fullWidth={true}
            />
          </Grid>

          {/* <Grid item xs={12} md={6} lg={4}>
            <GlobalSelectFieldWithoutFormikNew
              keys={{ itemId: 'id', itemValue: 'label' }}
              data={refundGlobalStatus}
              label={'Refund Status'}
              fullWidth={true}
              selectedDetails={selectedStatus}
              setChange={setSelectedStatus}
            />
          </Grid> */}
        </Grid>

        <GlobalDatagrid
          tableHead={COLUMNS}
          rows={refundRequestPmData?.data}
          meta={refundRequestPmData?.meta?.totalRecords}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
        />
        {approvalModal && (
          <GlobalRefundApprovalReject
            open={approvalModal}
            setOpen={setApprovalModal}
            rowData={selectedRow}
            dispatchParams={dispatchParams}
            loading={loading}
            action={'pm'}
            apiDispatchAfterSuccess={getPmRefundRequests}
          />
        )}
        {GLOBAL_DIALOGUE.map(({ open, content, setOpen, title }, i) => (
          <GlobalDialog
            key={i}
            maxWidth={'100%'}
            content={content}
            open={open}
            setOpen={setOpen}
            closeButton={true}
            title={title}
          />
        ))}
      </Box>
    </GlobalWrapper>
  );
};

export default RefundRequestPM;
